import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto',
      });

      return;
    }

    const elementId = hash.replace('#', '');

    const scrollToHash = () => {
      const element = document.getElementById(elementId);

      if (element) {
        element.scrollIntoView({
          behavior: 'auto',
          block: 'start',
        });
      }
    };

    // počakamo, da React najprej zrenderira ciljno stran
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(scrollToHash);
    });
  }, [pathname, hash]);

  return null;
}